var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warms",attrs:{"id":"header-warms"}},_vm._l((_vm.elements),function(el,key){return _c('div',{key:key,staticClass:"absolute rounded-full",style:(_vm.getWarmStyle(el))})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }